import ru from './ru.json';
import en from './en.json';
import fr from './fr.json';
import tr from './tr.json';

const langs = {
    ru,
    en,
    fr,
    tr
}

export default langs;
